import { format, parseISO, isValid } from 'date-fns';

export const dateFormatter = (timestamp, formate = null) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString();
}

export const dateToTimeStamp = (date = null) => {
    const validDate = date ? new Date(date) : new Date();
    return Math.floor(validDate.getTime() / 1000);
}

export const dateToTimeStampForList = (date = null) => {
    const validDate = date ? new Date(date) : new Date();
    return Math.floor(validDate.getTime());
}

export const toPostgresTimestamp = (input) => {
    if (input == null || input === '') {
        console.warn('toPostgresTimestamp: empty input');
        return '';
    }

    let epochMs;
    if (typeof input === 'number' || /^\d+$/.test(input)) {
        const n = Number(input);
        epochMs = n < 1e12 ? n * 1000 : n;
    } else {
        const parsed = parseISO(input);
        if (isValid(parsed)) {
            epochMs = parsed.getTime();
        } else {
            console.warn(`toPostgresTimestamp: invalid ISO date "${input}"`);
            return '';
        }
    }
    return format(new Date(epochMs), 'yyyy-MM-dd');
};


export const toHumanDate = (timestamp) => {
  return new Date(timestamp * 1000).toLocaleString();
}